module.exports = new __parcel__URL__("badger.0fb3ff8d.svg").toString();